// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 18/08/2025
import ChangeMeetingDateActionTypes from './change-meeting-date.type';

/***************   Start Update Branch Meeting Date ******************/
export const updateBranchMeetingDateStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_START,
	payload: getData,
});

export const updateBranchMeetingDateSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_SUCCESS,
	payload: successData,
});

export const updateBranchMeetingDateFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_FAILURE,
	payload: failureData,
});

export const updateBranchMeetingDateResponseResetStart = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_RESPONSE_RESET,
});

export const updateBranchMeetingDateResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_RESPONSE_CHANGED,
});
/***************   End Update Branch Meeting Date ******************/

/***************   Start Update Branch Meeting Date Auto Loan ******************/
export const updateBranchMeetingDateAutoLoanStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_START,
	payload: getData,
});

export const updateBranchMeetingDateAutoLoanSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_SUCCESS,
	payload: successData,
});

export const updateBranchMeetingDateAutoLoanFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_FAILURE,
	payload: failureData,
});

export const updateBranchMeetingDateAutoLoanResponseReset = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
});

export const updateBranchMeetingDateAutoLoanResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED,
});
/***************   End Update Branch Meeting Date Auto Loan ******************/

/***************   Get Branch Meeting Date Details Start ******************/
export const getBranchMeetingDateDetailsStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_START,
	payload: getData,
});

export const getBranchMeetingDateDetailsSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_SUCCESS,
	payload: successData,
});

export const getBranchMeetingDateDetailsFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_FAILURE,
	payload: failureData,
});

export const getBranchMeetingDateDetailsResponseResetStart = () => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_RESPONSE_RESET,
});

export const getBranchMeetingDateDetailsResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_RESPONSE_CHANGED,
});
/***************   Get Branch Meeting Date Details End ******************/

/***************   Get Branch Meeting Date Details Auto Loan Start ******************/
export const getBranchMeetingDateDetailsAutoLoanStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_START,
	payload: getData,
});

export const getBranchMeetingDateDetailsAutoLoanSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_SUCCESS,
	payload: successData,
});

export const getBranchMeetingDateDetailsAutoLoanFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_FAILURE,
	payload: failureData,
});

export const getBranchMeetingDateDetailsAutoLoanResponseReset = () => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_RESPONSE_RESET,
});

export const getBranchMeetingDateDetailsAutoLoanResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_RESPONSE_CHANGED,
});
/***************   Get Branch Meeting Date Details Auto Loan End ******************/

/***************  Get Loan Center Group Details Start ******************/
export const getLoanCenterGroupDetailsStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_START,
	payload: getData,
});

export const getLoanCenterGroupDetailsSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_SUCCESS,
	payload: successData,
});

export const getLoanCenterGroupDetailsFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_FAILURE,
	payload: failureData,
});

export const getLoanCenterGroupDetailsResponseResetStart = () => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_RESPONSE_RESET,
});

export const getLoanCenterGroupDetailsResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_RESPONSE_CHANGED,
});
/***************  Get Loan Center Group Details End ******************/

/***************  Get Loan Center Group Details Auto Loan Start ******************/
export const getLoanCenterGroupDetailsAutoLoanStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_START,
	payload: getData,
});

export const getLoanCenterGroupDetailsAutoLoanSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_SUCCESS,
	payload: successData,
});

export const getLoanCenterGroupDetailsAutoLoanFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_FAILURE,
	payload: failureData,
});

export const getLoanCenterGroupDetailsAutoLoanResponseReset = () => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_RESET,
});

export const getLoanCenterGroupDetailsAutoLoanResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_CHANGED,
});
/***************  Get Loan Center Group Details Auto Loan End ******************/

/***************  Get Loan Index Details Based On Center Group Start ******************/
export const getParticularLoanCenterGroupDetailsStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_START,
	payload: getData,
});

export const getParticularLoanCenterGroupDetailsSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_SUCCESS,
	payload: successData,
});

export const getParticularLoanCenterGroupDetailsFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_FAILURE,
	payload: failureData,
});

export const getParticularLoanCenterGroupDetailsResponseResetStart = () => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_RESPONSE_RESET,
});

export const getParticularLoanCenterGroupDetailsResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_RESPONSE_CHANGED,
});
/***************  Get Loan Index Details Based On Center Group End ******************/

/***************  Get Loan Index Details Based On Center Group Auto Loan Start ******************/
export const getParticularLoanCenterGroupDetailsAutoLoanStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_START,
	payload: getData,
});

export const getParticularLoanCenterGroupDetailsAutoLoanSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_SUCCESS,
	payload: successData,
});

export const getParticularLoanCenterGroupDetailsAutoLoanFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_FAILURE,
	payload: failureData,
});

export const getParticularLoanCenterGroupDetailsAutoLoanResponseReset = () => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_RESET,
});

export const getParticularLoanCenterGroupDetailsAutoLoanResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_CHANGED,
});
/***************  Get Loan Index Details Based On Center Group Auto Loan End ******************/

/***************   Start Update Branch New Meeting Date ******************/
export const updateSingleBranchMeetingDateStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_START,
	payload: getData,
});

export const updateSingleBranchMeetingDateSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_SUCCESS,
	payload: successData,
});

export const updateSingleBranchMeetingDateFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_FAILURE,
	payload: failureData,
});

export const updateSingleBranchMeetingDateResponseResetStart = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_RESPONSE_RESET,
});

export const updateSingleBranchMeetingDateResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_RESPONSE_CHANGED,
});
/***************   End Update Branch New Meeting Date ******************/

/***************   Start Update Branch New Meeting Date Auto Loan ******************/
export const updateSingleBranchMeetingDateAutoLoanStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_START,
	payload: getData,
});

export const updateSingleBranchMeetingDateAutoLoanSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_SUCCESS,
	payload: successData,
});

export const updateSingleBranchMeetingDateAutoLoanFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_FAILURE,
	payload: failureData,
});

export const updateSingleBranchMeetingDateAutoLoanResponseReset = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
});

export const updateSingleBranchMeetingDateAutoLoanResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED,
});
/***************   End Update Branch New Meeting Date Auto Loan ******************/

/***************  Update Loan Index Meeting Date Time Start ******************/
export const updateSingleCenterMeetingDateStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_START,
	payload: getData,
});

export const updateSingleCenterMeetingDateSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_SUCCESS,
	payload: successData,
});

export const updateSingleCenterMeetingDateFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_FAILURE,
	payload: failureData,
});

export const updateSingleCenterMeetingDateResponseResetStart = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_RESPONSE_RESET,
});

export const updateSingleCenterMeetingDateResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_RESPONSE_CHANGED,
});
/***************  Update Loan Index Meeting Date Time End ******************/

/***************  Update Loan Index Meeting Date Time Auto Loan Start ******************/
export const updateSingleCenterMeetingDateAutoLoanStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_START,
	payload: getData,
});

export const updateSingleCenterMeetingDateAutoLoanSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_SUCCESS,
	payload: successData,
});

export const updateSingleCenterMeetingDateAutoLoanFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_FAILURE,
	payload: failureData,
});

export const updateSingleCenterMeetingDateAutoLoanResponseReset = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
});

export const updateSingleCenterMeetingDateAutoLoanResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED,
});
/***************  Update Loan Index Meeting Date Time Auto Loan End ******************/

/***************  Update Loan Index Meeting Date Time Member Wise Start ******************/
export const updateSingleMemberMeetingDateStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_START,
	payload: getData,
});

export const updateSingleMemberMeetingDateSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_SUCCESS,
	payload: successData,
});

export const updateSingleMemberMeetingDateFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_FAILURE,
	payload: failureData,
});

export const updateSingleMemberMeetingDateResponseResetStart = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_RESPONSE_RESET,
});

export const updateSingleMemberMeetingDateResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_RESPONSE_CHANGED,
});
/***************  Update Loan Index Meeting Date Time Member Wise End ******************/

/***************  Update Loan Index Meeting Date Time Member Wise Auto Loan Start ******************/
export const updateSingleMemberMeetingDateAutoLoanStart = (getData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_START,
	payload: getData,
});

export const updateSingleMemberMeetingDateAutoLoanSuccess = (successData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_SUCCESS,
	payload: successData,
});

export const updateSingleMemberMeetingDateAutoLoanFailure = (failureData: any) => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_FAILURE,
	payload: failureData,
});

export const updateSingleMemberMeetingDateAutoLoanResponseReset = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
});

export const updateSingleMemberMeetingDateAutoLoanResponseChanged = () => ({
	type: ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED,
});
/***************  Update Loan Index Meeting Date Time Member Wise Auto Loan End ******************/
